import $ from 'jquery';
import _ from 'lodash-es';
import { initCollectionCarousels } from '../../../../../@infinite/scripts/sections/INF-CollectionCarousel/carousel';
import { standardizeHeights } from '../../../../../@infinite/scripts/core/INF-gridAlignment';
import { QuickView } from '../../../../../@infinite/scripts/components/INF-QuickView';

export default () => {
  // SHOPPABLE IMAGES
  $('.ShoppableImage').click((e) => {
    
    const products = $(e.currentTarget).data('products');
    const shoppable_images_url = `/pages/shoppable-image?products=${products}&cache=false`;

    $.get(shoppable_images_url, (html) => {
      
      const $content = $('<div />').html(html).find('.carousel-content');
      window.location.href = '#shoppable_products';
      $('.ModalShoppableProducts__container').empty();
      $('.ModalShoppableProducts__container').append($content);

      const grid_item_selector = '[data-collection-carousel-slide]';
      const child_selectors = [
        '[data-product-tile-image]',
        '[data-product-tile-title]',
      ];
      
      $(window).on('resize', () => {
        standardizeHeights(grid_item_selector, child_selectors);
      });

      initCollectionCarousels();
      standardizeHeights(grid_item_selector, child_selectors);   
            
      if (products.split(',').length === 1) {
        $('.ModalShoppableProducts').css('width', '300px');
        $('.ModalShoppableProducts .ProductItem').css('width', '100%');
      }
    });
  }); 
 
  QuickView();

  $('.ShoppableImage').css('width', $(this).find('img').css('width'));
  _.each($('.ShoppableImage'), (container) => {
    const $image_width = $(container).find('img').css('width');
    $(container).css('width', $image_width);
  });  
};